<template>
  <div>
    <a-card title="会员续费充值" class="card">
      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange">
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button type="danger" icon="transaction" size="small" @click="openFormModal(item)">充值/续费</a-button>

            </a-button-group>
          </div>

        </a-table>
      </a-row>
    </a-card>
    <form-modal v-model="visible" :form="targetItem" @create="create" @update="update" @list="list" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div>
        <a-spin style="margin-right: 12px;" />正在导入中, 请等待...
      </div>
    </a-modal>
  </div>
</template>

<script>
import { rechargeList } from '@/api/recharge'
import { orderCharge } from '@/api/recharge'

export default {
  name: 'Recharge',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
        },
        {
          title: '客户数量(条)',
          dataIndex: 'custom_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '供应商数量(条)',
          dataIndex: 'supplier_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '采购记录数量(条)',
          dataIndex: 'purchase_record_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '销售记录数量(条)',
          dataIndex: 'orders_record_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '入库记录数量(条)',
          dataIndex: 'instock_record_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '出库记录数量(条)',
          dataIndex: 'outstock_record_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '盘点记录数量(条)',
          dataIndex: 'inventory_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '付款数量(条)',
          dataIndex: 'payment_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '收款数量(条)',
          dataIndex: 'collection_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '日常收支数量(条)',
          dataIndex: 'daily_income_expend_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '账户转账数量(条)',
          dataIndex: 'account_transfer_quantity',
          customRender: (text, record) => {
            return '≤ ' + text
          },
        },
        {
          title: '售价/年',
          dataIndex: 'sale_price',
          key: 'index',
          customRender: (text, record, index) => {
            return '￥' + text
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '156px'
        },
      ],
      searchForm: { search: '', page: 1, page_size: 12 },
      pagination: { current: 1, total: 0, pageSize: 12 },
      loading: false,
      items: [],
      visible: false,
      targetItem: {},
      form: { is_active: true },
      importLoading: false,
    };
  },
  computed: {
  },
  methods: {
    initialize () {
      this.list();
    },
    list () {
      this.loading = true;
      rechargeList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;
      }).finally(() => {
        this.loading = false;
      });
    },
    create (item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update (item) {
      this.items.splice(this.items.findIndex(i => i.id == item.id), 1, item);
    },
    search () {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal (item) {
      console.log(item)
      if (item.id) {
        let formData = {
          goodId: item.id,
          goodPrice: parseInt(item.sale_price)
        };
        console.log(formData)
        orderCharge(formData).then(data => {
          console.log(data)
          if (data.imgUrl.code == 0) {
            this.targetItem = { ...item, ...{ imgUrl: data.imgUrl.data.url, order_no: data.imgUrl.data.order_no } };
            console.log(this.targetItem)
            this.$refs.FormModal.initialize()
          }
          else {
            this.$message.warn(data.imgUrl.message);
          }

        })
      } else {
        this.$message.warn("拉起第三方支付失败");
      }

      this.visible = true;
    },
    tableChange (pagination, filters, sorter) {
      //this.targetItem = {}
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
      this.list();
    },

  },
  mounted () {
    this.initialize();
  },
}
</script>
<style scoped>
.card {
  border-radius: 8px;
}
</style>